type FileIconProps = {
    className?: string;
    size?: number;
};

const FileIcon = ({ className, size = 16 }: FileIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            d="M9.33333 1.51318V4.26671C9.33333 4.64008 9.33333 4.82676 9.40599 4.96938C9.46991 5.09524 9.57149 5.19682 9.69735 5.26074C9.83997 5.3334 10.0267 5.3334 10.4 5.3334H13.1535M9.33333 11.3334H5.33333M10.6667 8.66671H5.33333M13.3333 6.65886V11.4667C13.3333 12.5868 13.3333 13.1469 13.1154 13.5747C12.9236 13.9511 12.6177 14.257 12.2413 14.4488C11.8135 14.6667 11.2535 14.6667 10.1333 14.6667H5.86667C4.74656 14.6667 4.18651 14.6667 3.75869 14.4488C3.38236 14.257 3.07641 13.9511 2.88465 13.5747C2.66667 13.1469 2.66667 12.5868 2.66667 11.4667V4.5334C2.66667 3.41329 2.66667 2.85324 2.88465 2.42542C3.07641 2.04909 3.38236 1.74314 3.75869 1.55138C4.18651 1.3334 4.74656 1.3334 5.86667 1.3334H8.00787C8.49688 1.3334 8.74138 1.3334 8.97168 1.38819C9.17672 1.43679 9.37266 1.51772 9.55215 1.62806C9.75482 1.75266 9.92672 1.92456 10.2705 2.26835L12.398 4.39593C12.7418 4.73972 12.9137 4.91162 13.0383 5.11429C13.1487 5.29378 13.2296 5.48972 13.2782 5.69476C13.333 5.92506 13.333 6.16956 13.333 6.65856L13.3333 6.65886Z"
            stroke="#18181B"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default FileIcon;
